import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxSprinklrWebwidgetService } from 'sprinklr-webwidget';
import { ToastsComponent } from 'toast';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, ToastsComponent],
})
export class AppComponent {
  private sprinklrService = inject(NgxSprinklrWebwidgetService);

  constructor() {
    this.sprinklrService.init();
  }
}
